var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "page-title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "search-area" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-input",
              {
                staticClass: "input-with-select",
                staticStyle: { width: "550px" },
                attrs: { placeholder: "Filter Files" },
                model: {
                  value: _vm.searchForm["fileName"],
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "fileName", $$v)
                  },
                  expression: "searchForm['fileName']"
                }
              },
              [
                _c("i", {
                  staticClass: "el-input__icon el-icon-search",
                  attrs: { slot: "prefix" },
                  slot: "prefix"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "search-button",
                    attrs: { slot: "append" },
                    on: { click: _vm.search },
                    slot: "append"
                  },
                  [_vm._v("\n          Search\n        ")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-sort",
                  icon:
                    _vm.clieckedSort == ""
                      ? "el-icon-sort"
                      : _vm.searchForm["sort"]
                      ? "el-icon-sort-up"
                      : "el-icon-sort-down"
                },
                on: {
                  click: function($event) {
                    _vm.searchForm["sort"] = !_vm.searchForm["sort"]
                    _vm.clieckedSort = 1
                  }
                }
              },
              [_vm._v("Sort\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                _vm.visible = true
              }
            }
          },
          [_vm._v("Upload files")]
        )
      ]),
      _vm._v(" "),
      !_vm.existsData
        ? _c("div", { staticClass: "no-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("p", [_vm._v("Upload and manage your files")]),
            _vm._v(" "),
            _c("p", [_vm._v("Files can be images(jpg/png/gif)")]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.visible = true
                    }
                  }
                },
                [_vm._v("Upload files")]
              )
            ])
          ])
        : _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    height: "calc(100vh - 276px)",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "File Name", "min-width": "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "table-name" }, [
                              _c("div", { staticClass: "table-img" }, [
                                _c("img", {
                                  attrs: { src: scope.row["link"], alt: "" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row["pname"]) +
                                    "\n            "
                                )
                              ])
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Date added",
                      prop: "createdAt",
                      "min-width": "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "size", "min-width": "100", label: "Size" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Link" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { icon: "el-icon-paperclip", round: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.copyLink($event, scope.row)
                                  }
                                }
                              },
                              [_vm._v("Copy")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("Pagination", {
                attrs: {
                  currentPage: _vm.searchForm.currentPage,
                  total: _vm.searchForm.total,
                  pageSize: _vm.searchForm.pageSize
                },
                on: {
                  handleSizeChange: _vm.handleSizeChange,
                  handleCurrentChange: _vm.handleCurrentChange
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "700px",
            "show-close": true,
            visible: _vm.visible,
            "destroy-on-close": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            close: _vm.closeDia
          }
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-area",
              attrs: {
                drag: "",
                limit: 15,
                headers: _vm.headers,
                accept: ".jpg,.png,.gif",
                "file-list": _vm.fileList,
                action: _vm.uploadApi,
                "on-preview": _vm.handlePreview,
                "on-remove": _vm.handleRemove,
                "on-exceed": _vm.handleExceed,
                "before-remove": _vm.beforeRemove,
                multiple: ""
              }
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("Drag files here, or"),
                _c("em", [_vm._v(" click Upload")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [
                  _vm._v(
                    "\n        The image format supports jpg/png/gif, <3M, up to 15 can be uploaded.\n      "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: {
          src: "https://master-shopvidi.s3.amazonaws.com/upload-detail.png"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52855f6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52855f6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/produts/images-list.vue
// module id = WtI/
// module chunks = 2